import {decodeHTML} from 'entities'
import sanitize from 'sanitize-html'

/**
 * Sanitizes HTML and prevents XSS attacks. You can feed `sanitizeHtml` with string full of dirty HTML and it will return a string with clean HTML
 * @param html - HTML string to sanitize
 * @returns A sanitized HTML
 */
export const sanitizeHtml = (html: string) => {
  return sanitize(html, {
    allowedTags: [...sanitize.defaults.allowedTags, 'img'],
    allowedAttributes: {
      ...sanitize.defaults.allowedAttributes,
      img: ['src', 'alt', 'width', 'height']
    }
  })
}

/**
 * Removes all markup, for the places that take text rather than HTML (JSON-LD
 * values, meta tags).
 * @param html - HTML string to flatten
 * @returns The text content, trimmed
 */
export const htmlToPlainText = (html: string) =>
  decodeHTML(sanitize(html, {allowedTags: [], allowedAttributes: {}})).trim()
